var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886",
    transform: "translate(-260 -3341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 30,
    height: 30,
    rx: 3,
    transform: "translate(260 3341)",
    fill: "#142454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_104498_facebook_icon",
    "data-name": "104498_facebook_icon",
    d: "M29.134,13.867h-3.8V11.376a1.014,1.014,0,0,1,1.057-1.154h2.68V6.11L25.382,6.1c-4.1,0-5.03,3.067-5.03,5.03v2.741h-2.37V18.1h2.37V30.1h4.984V18.1H28.7Z",
    transform: "translate(251.018 3337.904)",
    fill: "#f7f8f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c06b2e9230dea3c58f2af4ec87b62aac.svg";
export { ForwardRef as ReactComponent };